import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-646494aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "filterContainer" }
const _hoisted_2 = {
  id: "filteractivityLoggrid-content-loading",
  class: "text-center mt-3"
}
const _hoisted_3 = { class: "fa-2x" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { "aria-hidden": "true" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { "aria-hidden": "true" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { "aria-hidden": "true" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { "aria-hidden": "true" }
const _hoisted_14 = {
  key: 1,
  id: "period-message-text"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_table_heading = _resolveComponent("neu-table-heading")!
  const _component_neu_table_row = _resolveComponent("neu-table-row")!
  const _component_neu_input = _resolveComponent("neu-input")!
  const _component_neu_label = _resolveComponent("neu-label")!
  const _component_neu_checkbox = _resolveComponent("neu-checkbox")!
  const _component_neu_table_body = _resolveComponent("neu-table-body")!
  const _component_neu_table = _resolveComponent("neu-table")!
  const _component_neu_card = _resolveComponent("neu-card")!
  const _component_neu_paginator = _resolveComponent("neu-paginator")!
  const _component_neu_col = _resolveComponent("neu-col")!
  const _component_neu_table_row_count = _resolveComponent("neu-table-row-count")!
  const _component_neu_row = _resolveComponent("neu-row")!
  const _component_neu_container = _resolveComponent("neu-container")!
  const _component_ToasterPopup = _resolveComponent("ToasterPopup")!
  const _component_ConfirmationPopup = _resolveComponent("ConfirmationPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_font_awesome_icon, {
          spin: true,
          icon: ['fas', 'circle-notch'],
          size: "lg"
        })
      ]),
      _hoisted_4
    ], 512), [
      [_vShow, _ctx.isShowLoader]
    ]),
    _createVNode(_component_neu_card, {
      color: "plain-0",
      class: "p-0 m-0"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_neu_table, null, {
          default: _withCtx(() => [
            _createVNode(_component_neu_table_row, {
              columns: _ctx.columnHeaders,
              header: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.columnHeaders), (column) => {
                  return (_openBlock(), _createBlock(_component_neu_table_heading, {
                    key: column,
                    icon: _ctx.columnIcons[column],
                    slot: column
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(column), 1)
                    ]),
                    _: 2
                  }, 1032, ["icon", "slot"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["columns"]),
            _createVNode(_component_neu_table_body, { align: "left" }, {
              default: _withCtx(() => [
                (_ctx.filterPreferenceDetails != null && _ctx.filterPreferenceDetails.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.filterPreferenceDetails, (filter) => {
                      return (_openBlock(), _createBlock(_component_neu_table_row, {
                        columns: _ctx.columnHeaders,
                        key: filter,
                        slot: _ctx.column
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_neu_label, { slot: "FilterName" }, {
                            default: _withCtx(() => [
                              (filter.isVisibleNameLabel)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(filter.name), 1))
                                : _createCommentVNode("", true),
                              (filter.isVisibleNameText)
                                ? (_openBlock(), _createBlock(_component_neu_input, {
                                    key: 1,
                                    maxlength: "50",
                                    modelValue: filter.nameText,
                                    "onUpdate:modelValue": ($event: any) => ((filter.nameText) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_neu_label, { slot: "Facilities" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.buildFacilitiesServiceLineDeptsTemplate(filter.facilityNames)), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_neu_label, { slot: "Service Lines" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.buildFacilitiesServiceLineDeptsTemplate(filter.serviceLineNames)), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_neu_label, { slot: "Department" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.buildFacilitiesServiceLineDeptsTemplate(filter.departmentNames)), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_neu_label, { slot: "Default" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_neu_checkbox, {
                                id: "chkDefault",
                                name: "chkDefault",
                                class: "mr-10",
                                modelValue: filter.IsDefaultChecked,
                                "onUpdate:modelValue": ($event: any) => ((filter.IsDefaultChecked) = $event),
                                checked: filter.IsDefaultChecked,
                                disabled: filter.isDefaultCheckDisable
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "checked", "disabled"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_neu_label, { slot: "Action" }, {
                            default: _withCtx(() => [
                              (filter.isEditIconVisible)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: "#",
                                    class: "modaltoolbarIcon edit-button",
                                    title: "Edit",
                                    onClick: ($event: any) => (_ctx.onFilterEdit(filter.id))
                                  }, [
                                    _createElementVNode("i", _hoisted_7, [
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: ['fas', 'edit'],
                                        size: "lg"
                                      })
                                    ])
                                  ], 8, _hoisted_6))
                                : _createCommentVNode("", true),
                              (filter.isDeleteIconVisible)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    href: "#",
                                    class: "modaltoolbarIcon delete-button",
                                    title: "Delete",
                                    onClick: ($event: any) => (_ctx.onFilterDelete(filter.id))
                                  }, [
                                    _createElementVNode("i", _hoisted_9, [
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: ['fas', 'trash'],
                                        size: "lg"
                                      })
                                    ])
                                  ], 8, _hoisted_8))
                                : _createCommentVNode("", true),
                              (filter.isSaveIconVisible)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 2,
                                    href: "#",
                                    class: "modaltoolbarIcon save-button",
                                    title: "Save",
                                    onClick: ($event: any) => (_ctx.onFilterSave(filter.id))
                                  }, [
                                    _createElementVNode("i", _hoisted_11, [
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: ['fas', 'save'],
                                        size: "lg"
                                      })
                                    ])
                                  ], 8, _hoisted_10))
                                : _createCommentVNode("", true),
                              (filter.isSaveIconVisible)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 3,
                                    href: "#",
                                    class: "modaltoolbarIcon cancel-button",
                                    title: "Cancel",
                                    onClick: ($event: any) => (_ctx.onFilterCancel(filter.id))
                                  }, [
                                    _createElementVNode("i", _hoisted_13, [
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: ['fas', 'window-close'],
                                        size: "lg"
                                      })
                                    ])
                                  ], 8, _hoisted_12))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["columns", "slot"]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("p", _hoisted_14, "No data available on current page."))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.filterPreferenceDetails != null && _ctx.filterPreferenceDetails.length > 0)
      ? (_openBlock(), _createBlock(_component_neu_container, {
          key: 0,
          fluid: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_neu_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_neu_col, {
                  md: "6",
                  cols: "12",
                  class: "neu-text-center neu-text-md-left"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_neu_paginator, {
                      class: "justify-content-start",
                      onVNeuChange: _cache[0] || (_cache[0] = (ev) => this.pageNum = ev.detail.pageNumber),
                      total: _ctx.filterPreferenceDetails != null && _ctx.filterPreferenceDetails.length,
                      rowsPerPage: _ctx.rowsPerPage
                    }, null, 8, ["total", "rowsPerPage"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_neu_col, {
                  md: "6",
                  cols: "12",
                  class: "neu-text-center neu-text-md-right"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_neu_table_row_count, {
                      class: "mt-3",
                      section: "number",
                      total: _ctx.filterPreferenceDetails != null && _ctx.filterPreferenceDetails.length,
                      "page-number": _ctx.pageNum,
                      onVNeuChange: _ctx.rowCountChange
                    }, null, 8, ["total", "page-number", "onVNeuChange"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isToasterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(_component_ToasterPopup, {
            onCloseModal: _ctx.closeToasterPopup,
            msgValue: _ctx.msgValue,
            classFlag: _ctx.classFlag
          }, null, 8, ["onCloseModal", "msgValue", "classFlag"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isConfirmModalVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_component_ConfirmationPopup, {
            onCancelled: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isConfirmModalVisible = false)),
            onConfirmed: _ctx.confirmedClicked,
            msgValue: _ctx.confirmMsgValue
          }, null, 8, ["onConfirmed", "msgValue"])
        ]))
      : _createCommentVNode("", true)
  ]))
}